export default "__VITE_ASSET__BrkEOuox__"